export default __webpack_public_path__ + "static/Vulcain_LP2_Vulcainlogo-61f438f42c23708f0636b6ec0fcea497.png";